<template>
  <div v-if="isShow">
    <Modal v-model="isShow" :title="options.title" @on-ok="ok" :mask-closable="false">
      <p slot="header" style="color:#17233d">
        <span>{{options.title}}</span>
      </p>
      <div class="forml" v-if="options.input">
        <label>
          <span>{{options.input.label}}：</span>
        </label>
        <div class="forml_con">
          <textarea style="height:94px;width:360px" :maxlength="options.input.max" :placeholder="options.input.placeholder" v-model="options.input.value"></textarea>
        </div>
      </div>
      <p v-else class="textC">{{options.msg}}</p>
      <div slot="footer">
        <Button v-if="options.btn.no" @click="close()">{{options.btn.no}}</Button>
        <Button  type="error" @click="ok()">{{options.btn.ok}}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: true,
      options: {
        title: "",
        msg: "",
        input: "",
        btn: {
          ok: "",
          no: ""
        }
      }
    };
  },
  methods: {
    close() {},
    ok() {}
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/sub/yznconfirm.vue